__turbopack_context__.v({
  "className": "geist_mono_5dbb920e-module__MkXgQW__className",
  "variable": "geist_mono_5dbb920e-module__MkXgQW__variable",
});
